export const STANDARD_DRAFT_TIME_POLL_ID = "standard-draft-time-2026";
export const STANDARD_DRAFT_TIME_POLL_TITLE = "2026 Standard Draft Time";
export const STANDARD_DRAFT_TIME_POLL_DUE_ON = "2026-08-27";
export const STANDARD_DRAFT_TIME_POLL_DUE_MESSAGE =
  "Please complete your rankings by Thursday, August 27th.";
// America/Los_Angeles: full editing ends at the start of August 27, while
// voting remains open for new ballots and strict appends through August 27.
// If first place is tied at the scheduled close, that same locked-edit policy
// continues only until another ballot breaks the tie or every manager votes.
export const STANDARD_DRAFT_TIME_POLL_EDIT_CUTOFF_AT = 1_787_814_000;
export const STANDARD_DRAFT_TIME_POLL_CLOSE_AT = 1_787_900_400;

export const STANDARD_DRAFT_TIME_POLL_API_PATH =
  "/api/league/standard-draft-time-poll";
export const STANDARD_DRAFT_TIME_POLL_RESET_API_PATH =
  "/api/admin/standard-draft-time-poll/reset";

export const STANDARD_DRAFT_TIME_POLL_OPTIONS = [
  {
    id: "2026-09-03-1100-pt",
    label: "Thursday, September 3rd @ 11:00am PT",
    displayOrder: 1,
    startsAt: 1_788_458_400,
  },
  {
    id: "2026-09-03-1600-pt",
    label: "Thursday, September 3rd @ 4:00pm PT",
    displayOrder: 2,
    startsAt: 1_788_476_400,
  },
  {
    id: "2026-09-04-1100-pt",
    label: "Friday, September 4th @ 11:00am PT",
    displayOrder: 3,
    startsAt: 1_788_544_800,
  },
  {
    id: "2026-09-04-1600-pt",
    label: "Friday, September 4th @ 4:00pm PT",
    displayOrder: 4,
    startsAt: 1_788_562_800,
  },
  {
    id: "2026-09-05-1100-pt",
    label: "Saturday, September 5th @ 11:00am PT",
    displayOrder: 5,
    startsAt: 1_788_631_200,
  },
  {
    id: "2026-09-05-1600-pt",
    label: "Saturday, September 5th @ 4:00pm PT",
    displayOrder: 6,
    startsAt: 1_788_649_200,
  },
  {
    id: "2026-09-06-1100-pt",
    label: "Sunday, September 6th @ 11:00am PT",
    displayOrder: 7,
    startsAt: 1_788_717_600,
  },
  {
    id: "2026-09-06-1600-pt",
    label: "Sunday, September 6th @ 4:00pm PT",
    displayOrder: 8,
    startsAt: 1_788_735_600,
  },
  {
    id: "2026-09-07-1100-pt",
    label: "Monday, September 7th @ 11:00am PT (Labor Day)",
    displayOrder: 9,
    startsAt: 1_788_804_000,
  },
  {
    id: "2026-09-07-1600-pt",
    label: "Monday, September 7th @ 4:00pm PT (Labor Day)",
    displayOrder: 10,
    startsAt: 1_788_822_000,
  },
] as const;

export type StandardDraftTimePollOptionId =
  (typeof STANDARD_DRAFT_TIME_POLL_OPTIONS)[number]["id"];

export type StandardDraftTimePollEditMode =
  | "full"
  | "create"
  | "appendOnly"
  | "locked"
  | "closed";

export interface StandardDraftTimePollOption {
  id: StandardDraftTimePollOptionId;
  label: string;
  displayOrder: number;
  startsAt: number;
}

export interface StandardDraftTimePollBallot {
  rankedOptionIds: StandardDraftTimePollOptionId[];
  revision: number;
  updatedAt: number;
  status: "inProgress" | "complete";
}

export interface StandardDraftTimePollParticipation {
  electorateCount: number;
  complete: number;
  inProgress: number;
  notStarted: number;
  finished: boolean;
}

export interface StandardDraftTimePollResultOption {
  optionId: StandardDraftTimePollOptionId;
  label: string;
  displayOrder: number;
  points: number;
}

export interface StandardDraftTimePollResults {
  options: StandardDraftTimePollResultOption[];
  eligibleBallotCount: number;
}

export interface StandardDraftTimePollFinalization {
  finalizedAt: number;
  winnerOptionId: StandardDraftTimePollOptionId;
  winnerPoints: number;
  winningStandardDraftAt: number;
}

export interface StandardDraftTimePollDocument {
  poll: {
    id: typeof STANDARD_DRAFT_TIME_POLL_ID;
    title: string;
    dueOn: typeof STANDARD_DRAFT_TIME_POLL_DUE_ON;
    dueMessage: typeof STANDARD_DRAFT_TIME_POLL_DUE_MESSAGE;
    editCutoffAt: typeof STANDARD_DRAFT_TIME_POLL_EDIT_CUTOFF_AT;
    closeAt: typeof STANDARD_DRAFT_TIME_POLL_CLOSE_AT;
    options: StandardDraftTimePollOption[];
  };
  ballot: StandardDraftTimePollBallot | null;
  participation: StandardDraftTimePollParticipation | null;
  editMode: StandardDraftTimePollEditMode;
  /** True only after the scheduled close while an unresolved first-place tie
   * is waiting for another eligible manager's ballot. */
  tieBreakOpen: boolean;
  results: StandardDraftTimePollResults | null;
  finalization: StandardDraftTimePollFinalization | null;
}

export interface StandardDraftTimePollFinalizationResult {
  status: "not_due" | "tie_open" | "finalized" | "already_finalized";
  pollId: typeof STANDARD_DRAFT_TIME_POLL_ID;
  closeAt: typeof STANDARD_DRAFT_TIME_POLL_CLOSE_AT;
  finalization: StandardDraftTimePollFinalization | null;
}

export interface StandardDraftTimePollResetResult {
  reset: true;
  idempotent: boolean;
  idempotencyKey: string;
  deletedBallots: number;
}
